'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _errorModalConstants = require('./errorModalConstants');

var initialState = null;

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _errorModalConstants.ERROR_MODAL_OPEN:
            return action.modalId;
        case _errorModalConstants.ERROR_MODAL_CLOSE:
            return initialState;
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/error/modals/activeErrorModalIdReducer.js
// module id = 1763
// module chunks = 0